import React from 'react';
import MediaQuery from 'react-responsive';

import './Industry.css';
import IndustryImage from '../../images/home/home-industry-oculus.png';

function IndustrySection() {
  return (
    <div className="IndustrySection">
      <div className="title">
        <p>
        We develop innovative solutions
          <MediaQuery query="(min-width: 425px)">
            <br />
          </MediaQuery>
          <MediaQuery query="(max-width: 425px)">
            {' '}
          </MediaQuery>
          through multi-disciplinary applications in order to
          <MediaQuery query="(min-width: 425px)">
            <br />
          </MediaQuery>
          <MediaQuery query="(max-width: 425px)">
            {' '}
          </MediaQuery>
          <span>impact the market with cutting-edge technology.</span>
        </p>
      </div>
      <div className="industriesList">
        <ul>
          <li>AGRIBUSINESS</li>
          <li>INDUSTRY 4.0</li>
          <li>REATIL</li>
          <li>EDUCATION</li>
          <li>ENGINEERING</li>
          <li>HEALTHY</li>
        </ul>
        <img src={IndustryImage} alt="man with HMD and bracelet controlling game on tv" />
      </div>
    </div>
  );
}

export default IndustrySection;
